import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotificationRequest } from "../../store/notification/notification.actions";
import { getNotificationList } from "../../store/notification/notification.selector";
import {
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";
import _ from "underscore";

const AllNotifications = () => {
    const dispatch = useDispatch();
    const { allNotifications, userProfile, users } = useSelector((state) => {
        return {
            allNotifications: getNotificationList(state),
            userProfile: getUserProfile(state),
            users: getSearchedUsers(state),
        };
    });

    useEffect(() => {
        dispatch(fetchNotificationRequest());
    }, []);

    let notifications = _.sortBy(allNotifications.data, "isRead");
    notifications = _.sortBy(notifications, (x) => {
        return new Date(x.dateCreated);
    }).reverse();

    let notRead = notifications.filter((x) => !x.isRead);

    let desc = <p></p>;

    notifications = notifications.filter(
        (x) => x.type !== "chatRoom" && x.type !== "inbox"
    );

    return (
        <div className="space-y-3.5">
            {notifications.map((notify) => {
                return (
                    <div
                        key={notify.id}
                        className="flex justify-between items-start gap-x-2.5 mb pb-[18px] border-b border-black-5 "
                    >
                        <div className="flex items-start gap-x-4">
                            <img
                                src={notify.img}
                                className="w-10 md:w-12 h-10 md:h-12 rounded-full"
                                alt=""
                            />
                            <div className="">
                                <h4 className="text-sm md:text-base font-bold text-ebony-color mb-1.5">
                                    {notify.name}
                                </h4>
                                <p className="text-sm md:text-sm text-[#707A89]">
                                    {notify.notify}{" "}
                                    <span className="text-purple-color capitalize inline-block ml-1">
                                        test
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div className="text-right">
                            <button className="text-orange-color text-sm md:text-sm font-medium mb-1.5 whitespace-nowrap">
                                Watch Again
                            </button>
                            <p className="text-extraSmall md:text-sm text-[#707A89]">
                                {notify.time}
                            </p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default AllNotifications;
